import MessageHeader from "./MessageHeader";

const MessageItem = ({
  fromClient,
  messageSentTime,
  message,
  userData,
}: {
  fromClient: boolean;
  messageSentTime: number;
  message: string;
  userData: any;
}) => {
  return (
    <div className={`message ${fromClient ? "right" : "left"}`}>
      <MessageHeader
        fromClient={fromClient}
        messageSentTime={messageSentTime}
        userData={userData}
      />
      <div className="message__main">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default MessageItem;
